import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { API_URL } from 'constants';
import { securityHeaders } from 'helpers/headers';
import { useToast } from 'app-context/toasterContext/ToastContext';
const handleUnauthorized = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('AIDucator_userId');
  if (window.location.pathname !== '/') {
    setTimeout(() => {
      window.location.href = '/';
    }, 50);
  }
};
const fetchData = async (url, params) => {
  const headers = securityHeaders();

  try {
    const validParams =
      params && typeof params === 'object'
        ? Object.fromEntries(
            Object.entries(params).filter(
              ([_, value]) =>
                value !== '' && value !== null && value !== undefined
            )
          )
        : null;

    const queryString =
      validParams && Object.keys(validParams).length > 0
        ? Object.entries(validParams)
            .map(
              ([key, value]) =>
                `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
            )
            .join('&')
        : '';

    const finalUrl = queryString
      ? `${API_URL}${url}?${queryString}`
      : `${API_URL}${url}`;

    const response = await axios.get(finalUrl, { headers });
    return response;
  } catch (error) {
    const status = error?.response?.status;
    if (status === 401) {
      handleUnauthorized();
    }
    throw error;
  }
};

export const useFetch = (queryKey, url, options = {}, params, interval) => {
  const toast = useToast();

  return useQuery({
    queryKey: queryKey,
    queryFn: () => fetchData(url, params),
    refetchOnWindowFocus: options.refetchOnWindowFocus || false,
    refetchInterval: interval || false,
    enabled: options.enabled !== false,
    onError:
      options.onError ||
      ((error) => {
        const status = error?.response?.status;
        const userMessage =
          error?.response?.data?.userMessage ||
          'Something went wrong, please try again later.';

        if (status === 401) {
          handleUnauthorized();
          return;
        }

        if (!options.disableToast) {
          toast.open(userMessage, 'error');
        }
      }),
    ...options,
  });
};
